import React from 'react';
import PayBonusButton from './PayBonusButton';
import OfferRateButton from './OfferRateButton';

const BUTTON_SIZE = 'tiny';

const DBCActions = ({ job }) => (
  <div>
    <OfferRateButton job={job} />
    {/* Remove condition if we want to allow clients to make bonus payments */}
    <PayBonusButton job={job} size={BUTTON_SIZE} />
  </div>
);

export default DBCActions;
